<script lang="ts">
export default {
    name: 'ResetPassword',
    setup() {
        const runtimeConfig = useRuntimeConfig()
        const route = useRoute()

        definePageMeta({ layout: 'empty' })
        useHead({
            title: 'Mot de passe oublié',
            meta: [
                { name: 'description', content: 'Mot de passe oublié' },
            ],
        })
        return {
            runtimeConfig,
            route,
        }
    },
    data: () => ({
        password: null,
        passwordConfirm: null,
        resetting: false,
        visible: false,
    }),
    mounted() {
    },
    methods: {
        async resetPassword() {
            this.resetting = true
            const route = {
                url: 'password',
                method: 'POST',
                body: {
                    token: this.route.params.token as string,
                    password: this.password,
                    password_confirmation: this.passwordConfirm,
                    email: this.route.query.email,
                },
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }
            const res = await this.$api.setRequest(route)
            if (res) {
                this.$showToaster({
                    title: 'Réinitialisation',
                    text: `Votre nouveau mot de passe est maintenant actif`,
                    color: 'success',
                    icon: 'mdi-check-circle',
                    timer: -1,
                })
                this.$router.push('/connexion')
            }
            this.resetting = false
        },
    },
}
</script>

<template>
    <div>
        <v-container class="pa-0">
            <v-row
                class="h-screen"
                justify="center"
                align="center"
            >
                <v-col cols="12">
                    <v-card
                        class="mx-auto pa-10"
                        elevation="8"
                        max-width="600"
                        rounded="lg"
                    >
                        <v-form
                            validate-on="submit lazy"
                            @submit.prevent="resetPassword"
                        >
                            <div class="w-100 text-center">
                                <img
                                    class="mx-auto"
                                    src="@nuxtcommon/assets/images/logo.png"
                                    alt="Pildom"
                                >
                            </div>

                            <p class="text-subtitle-2 text-center py-6 font-italic">
                                Renseigner votre nouveau mot de passe
                            </p>

                            <label class="text-subtitle-1 text-medium-emphasis" for="password">
                                Mot de passe
                                <span v-html="$config.public.form_label_required_text || '*'" />
                            </label>
                            <div class="text-caption text-medium-emphasis">
                                Le mot de passe doit contenir au moins un chiffre, une lettre minuscule, une lettre majuscule, un caractère spécial et doit avoir une longueur minimale de 14 caractères.
                            </div>

                            <v-row>
                                <v-col>
                                    <v-text-field
                                        id="password"
                                        v-model="password"
                                        density="compact"
                                        prepend-inner-icon="mdi-lock-outline"
                                        variant="outlined"
                                        :type="visible ? 'text' : 'password'"
                                    />
                                </v-col>
                                <v-col cols="2" class="px-0">
                                    <v-btn
                                        color="primary"
                                        class="my-1"
                                        aria-label="Afficher ou cacher le mot de passe"
                                        @click="visible = !visible"
                                    >
                                        <v-icon :icon="visible ? 'mdi-eye-off' : 'mdi-eye'" />
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <label class="text-subtitle-1 text-medium-emphasis" for="confirm">
                                Confirmation du mot de passe
                                <span v-html="$config.public.form_label_required_text || '*'" />
                            </label>

                            <v-text-field
                                id="confirm"
                                v-model="passwordConfirm"
                                density="compact"
                                prepend-inner-icon="mdi-lock-outline"
                                variant="outlined"
                                :type="visible ? 'text' : 'password'"
                            />

                            <v-btn
                                type="submit"
                                :loading="resetting"
                                block
                                class="my-4"
                                color="primary"
                                size="large"
                            >
                                Changer le mot de passe
                            </v-btn>
                            <v-btn
                                block
                                class="my-4"
                                color="secondary"
                                size="large"
                                variant="flat"
                                @click="$router.replace('/#connexion')"
                            >
                                Retourner à l'écran de connexion
                            </v-btn>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
